<template>
  <a class="app-link-open" rel="noopener noreferrer" target="_blank"
     :href="url">{{ props.name ? props.name : props.url }}<span class="sr-only">(opens in a new window or tab)</span></a>
</template>

<script setup>
defineOptions({
  name: 'BaseLinkOpenNew'
});

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: false,
  }
})
</script>
